(function(){

var WK_PC_CUST =
  {
    'html_Bar':'<div class="wk_pc_cust_accordian_bar"><div class="bar-info"><span class="bar-text">compare<span></div><div class="bar-icon"><i class="arrow down"></div></div>'
    ,
    'getCookie': function (key){

  			var cookie_arr = document.cookie.split(';');
  			var i;
  			var nv_arr;

  			for (i = 0;i<=cookie_arr.length-1;i++)
  			{
  				nv_arr = cookie_arr[i].split('=');
  				if(nv_arr[0].trim()==key)
  				{
  					return nv_arr[1];
  				}
  				else
  					nv_arr[1] = false;
  			}


				if(nv_arr[1])
					return nv_arr[1].trim();
				else
					console.log(nv_arr[1]);
		}
    ,'HideContent':
      function(){
        $('.wk_compare_products_block .wk_wrapper').slideUp('fast',function(){

                                                    });

        $('.wk_pc_cust_accordian_bar .bar-icon i').removeClass('up');
        $('.wk_pc_cust_accordian_bar .bar-icon i').addClass('down');

      }
    ,
    'ShowContent':
    function(){
      $('.wk_compare_products_block .wk_wrapper').slideDown('fast',function(){

                                                  });
      $('.wk_pc_cust_accordian_bar .bar-icon i').removeClass('down');
      $('.wk_pc_cust_accordian_bar .bar-icon i').addClass('up');


    }
    ,
    'Add_Bar':
    function()
    {

      if($('.wk_compare_products_block').length)
      {
        //delay for executing code after dom manipulation by product diff script tag
        setTimeout(function(){
          var cookie_data = WK_PC_CUST.getCookie('wk_cmp_data');
          if(cookie_data)
            if(!$('.wk_compare_products_block .wk_pc_cust_accordian_bar').length)
                $('.wk_compare_products_block').prepend(WK_PC_CUST.html_Bar);
        },1000)

      }
      else {
        console.log('wk_compare_products_block not exist');
      }
    },
    'Bind_Event':
    function()
    {

        $('.wk_compare_products_block ').on('click','.wk_pc_cust_accordian_bar',function(e){
            $(this).toggleClass('closed');
            WK_PC_CUST.Check()
        })

        //add Bar on click
        $('.wk_product_comparison').on('click','[name="compare_checkbox"]',function(e){

            WK_PC_CUST.Add_Bar();
        })

    },
    'Check':
    function()
    {

      if($('.wk_pc_cust_accordian_bar').hasClass('closed'))
      {
            WK_PC_CUST.HideContent();
      }
      else {

          WK_PC_CUST.ShowContent();
      }
    },
    'Start':function()
    {
        WK_PC_CUST.Add_Bar();
        WK_PC_CUST.Bind_Event();

    },

  }

  $(document).ready(function(){
      window.WK_PC_CUST = WK_PC_CUST;
      WK_PC_CUST.Start();
  })

}).call(this);
